import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { BRAND, LOGOS } from "@/brand";

export default function Preloader({ onDone }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const start = Date.now();
    const duration = 1900;
    const tick = () => {
      const p = Math.min(100, Math.floor(((Date.now() - start) / duration) * 100));
      setProgress(p);
      if (p < 100) {
        requestAnimationFrame(tick);
      } else {
        setTimeout(onDone, 450);
      }
    };
    requestAnimationFrame(tick);
  }, [onDone]);

  return (
    <motion.div
      data-testid="loading-screen-preloader"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0A0A0B] concrete-grain"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.85, filter: "blur(8px)" }}
        animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
        transition={{ duration: 1, ease: "easeOut" }}
        className="flex flex-col items-center gap-6 px-6 text-center"
      >
        <img
          src={LOGOS.emblem}
          alt={BRAND.name}
          data-testid="preloader-logo"
          className="logo-blend w-64 sm:w-80"
        />
        <p className="text-[10px] tracking-[0.4em] text-zinc-600 uppercase">{BRAND.short}</p>
      </motion.div>
      <div className="absolute bottom-10 left-6 right-6 sm:left-12 sm:right-12">
        <div className="flex items-end justify-between">
          <span className="text-[10px] tracking-[0.35em] text-zinc-600 uppercase">Entering the vault</span>
          <span data-testid="preloader-progress-counter" className="font-display text-5xl sm:text-6xl chrome-text leading-none">
            {String(progress).padStart(3, "0")}%
          </span>
        </div>
        <div className="mt-3 h-px w-full bg-zinc-800">
          <div className="h-px bg-zinc-300 transition-[width] duration-100" style={{ width: `${progress}%` }} />
        </div>
      </div>
    </motion.div>
  );
}
